"use client";

import * as S from "./styles.ts";
import NumberPickerTabs from "@template/blocks/NumberPickerSection/component/NumberPickerTabs";
import { H1, H2, H3, P, UniversalLink } from "@template/components";
import TransfersInCart from "@template/blocks/NumberTransferSection/component/TransfersInCart";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";

const DisclaimerCard = () => (
  <S.Disclaimer>
    <P>
      To make the phone number transfer process as quick and easy as possible,
      we require that you provide documentation to prove you currently own the
      number. Documentation can be emailed to us directly or sent via a form
      from your account dashboard.
    </P>
    <UniversalLink
      href="/faq/phone-numbers/transfer-requirements/"
      title="Find out what a transfer requires"
      styled
    >
      What do I need to provide in order to transfer my number to Yay.com?
    </UniversalLink>
  </S.Disclaimer>
);

const headingComponents = { H1, H2, H3 } as const;

const NumberTransfer = ({
  altStyling = false,
  needHeading = false,
  needDesclaimerCard = true,
  headingTag = "H1",
  heading,
  description,
  context,
}: {
  altStyling?: boolean;
  needHeading?: boolean;
  needDesclaimerCard?: boolean;
  headingTag?: keyof typeof headingComponents;
  heading?: string;
  description?: string;
  context?: "virtualLandline" | "individual" | "standard" | "transfer";
}) => {
  const Heading = headingComponents[headingTag] ?? H1;

  return (
    <S.NumberTransferSectionWrapper
      $altStyling={altStyling}
      $hasHeading={needHeading}
    >
      {altStyling && (
        <ArchStandaloneSectionComponent
          color="white"
          background="dark"
          style={{
            position: "absolute",
            top: needHeading ? 300 : 160,
            zIndex: 0,
          }}
        />
      )}
      {needHeading && (
        <S.NumberTransferHeader $altStyling={altStyling}>
          {heading && <Heading>{heading}</Heading>}
          {description && <P $textAlign="center">{description}</P>}
        </S.NumberTransferHeader>
      )}
      <S.NumberTransferSectionContainer>
        <NumberPickerTabs
          defaultKey="transfer"
          needHeading={needHeading}
          context={context}
        />
        {needDesclaimerCard && <DisclaimerCard />}
        <TransfersInCart />
      </S.NumberTransferSectionContainer>
    </S.NumberTransferSectionWrapper>
  );
};

export default NumberTransfer;

export const options = [
  {
    description: "",
    displayName: "NumberTransfer",
    methods: [],
    props: {
      altStyling: {
        required: false,
        flowType: { name: "boolean" },
        description: "",
        defaultValue: { value: "false", computed: false },
      },
    },
  },
];
